import { useSelector, useDispatch } from 'react-redux';
import { editSettingsProp } from 'state/fence/fenceSlice';
import { closeModal } from 'state/modal/modalSlice';
import ModalBase from 'components/common/ModalBase/ModalBase';
import FormLabel from 'components/common/FormLabel/FormLabel';
import FormCheck from 'components/common/FormCheck/FormCheck';
import ButtonBase from 'components/common/ButtonBase/ButtonBase';

const ModalEditRailStyle = () => {
  const dispatch = useDispatch();
  const fence = useSelector((state) => state.fence);

  const changeRailDirectionHandler = (value) => {
    dispatch(editSettingsProp({ prop: 'railDirection', value }));
  };

  const changeRailColorHandler = (value) => {
    dispatch(editSettingsProp({ prop: 'railColor', value }));
  };

  const saveElement = () => {
    dispatch(closeModal());
  };

  return (
    <ModalBase title="Kerítés léc megjelenése">
      <div className="row align-items-center mb-sm">
        <div className="col-3">
          <FormLabel>Léc kiosztás:</FormLabel>
        </div>
        <div className="col-9">
          <div className="row">
            <div className="col-6">
              <FormCheck mode="box"
                type="radio"
                name="rail-direction"
                groupValue={fence.settings.railDirection}
                value="horizontal"
                onChange={changeRailDirectionHandler}
              >
                Vízszintes
              </FormCheck>
            </div>
            <div className="col-6">
              <FormCheck mode="box"
                type="radio"
                name="rail-direction"
                groupValue={fence.settings.railDirection}
                value="vertical"
                onChange={changeRailDirectionHandler}
              >
                Függőleges
              </FormCheck>
            </div>
          </div>
        </div>
      </div>

      <div className="row align-items-center mb-md">
        <div className="col-3">
          <FormLabel>Szín:</FormLabel>
        </div>
        <div className="col-9">
          <div className="row">
            <div className="col-4">
              <FormCheck mode="box"
                type="radio"
                name="rail-color"
                groupValue={fence.settings.railColor}
                value="dark"
                onChange={changeRailColorHandler}
              >
                Sötét
              </FormCheck>
            </div>
            <div className="col-4">
              <FormCheck mode="box"
                type="radio"
                name="rail-color"
                groupValue={fence.settings.railColor}
                value="light"
                onChange={changeRailColorHandler}
              >
                Világos
              </FormCheck>
            </div>
            <div className="col-4">
              <FormCheck mode="box"
                type="radio"
                name="rail-color"
                groupValue={fence.settings.railColor}
                value="brown"
                onChange={changeRailColorHandler}
              >
                Barna
              </FormCheck>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-md">
        <div className="col-6 ms-auto me-auto">
          <ButtonBase color="primary" className="w-full" onClick={saveElement}>
            Bezárás
          </ButtonBase>
        </div>
      </div>

      <p className="text-center mb-none">
        A kerítés betét elemek csak a látványterv részeként értelmezendőek,{' '}
        <strong>forgalmazásukkal nem foglalkozunk!</strong>
      </p>
    </ModalBase>
  );
};

export default ModalEditRailStyle;
